import { render, staticRenderFns } from "./peddlrWalletLimit.vue?vue&type=template&id=46ff6d30"
import script from "./peddlrWalletLimit.vue?vue&type=script&lang=js"
export * from "./peddlrWalletLimit.vue?vue&type=script&lang=js"
import style0 from "./peddlrWalletLimit.vue?vue&type=style&index=0&id=46ff6d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports